import {
  CommonIncidentId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'

export const VolleyballHideIncidentIds = [
  VolleyballIncidentId.StartDelayed,
  VolleyballIncidentId.MatchAboutToStart,
  VolleyballIncidentId.FirstSetStarted,
  VolleyballIncidentId.BreakAfter,
  VolleyballIncidentId.BreakAfterFirstSet,
  VolleyballIncidentId.SecondSetStarted,
  VolleyballIncidentId.BreakAfterSecondSet,
  VolleyballIncidentId.ThirdSetStarted,
  VolleyballIncidentId.BreakAfterThirdSet,
  VolleyballIncidentId.FourthSetStarted,
  VolleyballIncidentId.BreakAfterFourthSet,
  VolleyballIncidentId.FifthSetStarted,
  VolleyballIncidentId.BreakAfterFifthSet,
  VolleyballIncidentId.GoldenSetStart,
  VolleyballIncidentId.Finished,
  VolleyballIncidentId.Interrupted,
  CommonIncidentId.TechnicalProblems,
  CommonIncidentId.Betstart,
  CommonIncidentId.Betstop,
  VolleyballIncidentId.ServiceAce,
  VolleyballIncidentId.ServiceError,
  VolleyballIncidentId.AttackPoint,
  VolleyballIncidentId.AttackError,
  VolleyballIncidentId.BlockPoint,
  VolleyballIncidentId.TechnicalErrors,
  VolleyballIncidentId.Point,
  VolleyballIncidentId.Serve,
  VolleyballIncidentId.NeutralAttack,
  VolleyballIncidentId.Reception,
  VolleyballIncidentId.Dig,
  VolleyballIncidentId.Set,
  VolleyballIncidentId.Cards,
  VolleyballIncidentId.Challenge,
  VolleyballIncidentId.RefereeChallenge,
  VolleyballIncidentId.Timeout,
  VolleyballIncidentId.TimeoutOver,
  VolleyballIncidentId.InPossession,
  VolleyballIncidentId.SetBall,
  VolleyballIncidentId.MatchBall,
  VolleyballIncidentId.RepeatAction,
  VolleyballIncidentId.PlayerChangeSides,
  VolleyballIncidentId.BreakDuringTheGame,
]

export const VolleyballParticipantIncidentIds = [
  VolleyballIncidentId.ServiceAce,
  VolleyballIncidentId.ServiceError,
  VolleyballIncidentId.AttackPoint,
  VolleyballIncidentId.AttackError,
  VolleyballIncidentId.BlockPoint,
  VolleyballIncidentId.TechnicalErrors,
  VolleyballIncidentId.Point,
  VolleyballIncidentId.Serve,
  VolleyballIncidentId.NeutralAttack,
  VolleyballIncidentId.Reception,
  VolleyballIncidentId.Dig,
  VolleyballIncidentId.Set,
  VolleyballIncidentId.Cards,
]

export const VolleyballSecondParticipantIncidentIds = [
  VolleyballIncidentId.ServiceAce,
  VolleyballIncidentId.BlockPoint,
]

export const VolleyballDetailsIncidentIds = [
  VolleyballIncidentId.AttackPoint,
  VolleyballIncidentId.BlockPoint,
  VolleyballIncidentId.AttackError,
  VolleyballIncidentId.TechnicalErrors,
  VolleyballIncidentId.NeutralAttack,
  VolleyballIncidentId.Reception,
  VolleyballIncidentId.Dig,
  VolleyballIncidentId.Cards,
]
